<template>
    <section class="resume-section language-section mb-5">
        <h2 class="resume-section-title text-uppercase font-weight-bold pb-3 mb-3">{{data.section.title}}</h2>
        <div class="resume-section-content">
            <ul class="list-unstyled resume-lang-list">
                <li v-for="(language, index) in data.list" :key="index" class="mb-2"
                    :class="{'align-middle': index === 1}">
                    <span class="resume-lang-name font-weight-bold">{{language.name}}</span>
                    <small class="text-muted font-weight-normal">({{language.level}})</small>
                </li>
            </ul>
        </div>
    </section>
</template>
<script>
    export default {
        name: "Languages",
        computed: {
            data() {
                return this.$store.state.languages[this.$store.state.config.lang];
            }
        }
    }
</script>
<style lang="sass" scoped>
    @import "./../../sass/constants"
    .resume-lang-name
        color: $gray-blue
</style>